import { styled } from 'styled-components';
import { Vote } from '../api/types';
import { StarFilled } from '@ant-design/icons';

export const VoteResult = ({ votes }: { votes: Vote[] }) => {
  return (
    <Result>
      {votes.length === 0 ? (
        'No votes yet, be the first to vote!'
      ) : (
        <>
          <StarFilled style={{ color: '#EFB143' }} />
          &nbsp;
          {(
            votes.reduce(
              (total: number, current: Vote) => total + current.vote,
              0.0
            ) / votes.length
          ).toFixed(1)}
          &nbsp;({votes.length} votes)
        </>
      )}
    </Result>
  );
};

const Result = styled.div`
  color: #aaaaaa;
  font-size: 16px;
`;
